<template>
    <div :class="`box${show ? ' selected' : ''}`">
        <i @click="toggle" class="icon-set"></i>
        <div @click="send" class="tip">取消收藏</div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            key: 0,
        }),
        computed: {
            state() {
                return this.$store.state;
            },
            collectSet() {
                return this.state.collectSet;
            },
            keys() {
                return this.collectSet.keys;
            },
            openKey() {
                return this.collectSet.openKey;
            },
            show() {
                return this.keys[this.key];
            }
        },
        methods: {
            entrust(e) {
                const {target} = e;
                if (target && target.className !== 'icon-set') this.close();
            },
            close() {
                this.$set(this.keys, this.openKey, false);
            },
            toggle() {
                if (this.show) {
                    this.close();// 关闭被打开的表情包
                } else {
                    this.close();
                    this.$set(this.keys, this.key, true);// 打开当前表情包
                    this.collectSet.openKey = this.key;
                }
            },
            send() {
                this.$emit('send');
            }
        },
        created() {
            this.keys.push(false);
            this.key = this.keys.length - 1;// 唯一标识

            if (this.collectSet.hasCloseFn) return;
            this.collectSet.hasCloseFn = true;
            document.addEventListener('click', this.entrust);
        },
        beforeDestroy() {
            const {collectSet} = this;
            if (!collectSet.hasCloseFn) return;
            collectSet.hasCloseFn = false;
            collectSet.keys = [];
            document.removeEventListener('click', this.entrust);
        }
    }
</script>

<style scoped>
    @import "../../../../static/css/views/space/collect/set.css";
</style>


// WEBPACK FOOTER //
// src/views/space/collect/Set.vue